import React, { useState, useEffect, useCallback, useMemo } from 'react';
import { useNavigate } from 'react-router-dom';
import { Card, CardContent, CardHeader, CardTitle } from '../../components/ui/card';
import { Button } from '../../components/ui/button';
import { Input } from '../../components/ui/input';
import { Label } from '../../components/ui/label';
import { Textarea } from '../../components/ui/textarea';
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter } from '../../components/ui/dialog';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '../../components/ui/select';
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from '../../components/ui/table';
import { Tabs, TabsContent, TabsList, TabsTrigger } from '../../components/ui/tabs';
import { Command, CommandEmpty, CommandGroup, CommandInput, CommandItem, CommandList } from '../../components/ui/command';
import { Popover, PopoverContent, PopoverTrigger } from '../../components/ui/popover';
import { Badge } from '../../components/ui/badge';
import { Switch } from '../../components/ui/switch';
import { Collapsible, CollapsibleContent, CollapsibleTrigger } from '../../components/ui/collapsible';
import { toast } from 'sonner';
import { 
  TrendingUp, 
  TrendingDown, 
  Plus, 
  
  Search, 
  Upload, 
  Check, 
  ChevronsUpDown, 
  X,
  Calendar,
  CreditCard,
  Banknote,
  FileText,
  CheckCircle,
  Clock,
  Eye,
  Image,
  Filter,
  Download,
  ChevronDown,
  Briefcase,
  ArrowUpDown,
  ArrowUp,
  ArrowDown,
  AlertTriangle,
  CalendarClock
} from 'lucide-react';
import { cn } from '../../lib/utils';
import DocumentPreviewModal from '../../components/DocumentPreviewModal';
import JobDetailPopup from '../../components/JobDetailPopup';

const AccountingTakipler = () => {
  const navigate = useNavigate();
  const [activeMainTab, setActiveMainTab] = useState('alacak');
  const [activeSubTab, setActiveSubTab] = useState('devam');
  const [takipler, setTakipler] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [showDetailModal, setShowDetailModal] = useState(false);
  const [showOdemeModal, setShowOdemeModal] = useState(false);
  const [editingTakip, setEditingTakip] = useState(null);
  const [selectedTakip, setSelectedTakip] = useState(null);
  const [showDocPreview, setShowDocPreview] = useState(false);
  const [previewBelgeler, setPreviewBelgeler] = useState([]);
  const [selectedOdeme, setSelectedOdeme] = useState(null);
  const [searchTerm, setSearchTerm] = useState('');
  const [showFilters, setShowFilters] = useState(false);
  
  // Sorting state
  const [sortConfig, setSortConfig] = useState({ key: 'olusturma_tarihi', direction: 'desc' });
  
  // İş referansı state
  const [pendingJobAction, setPendingJobAction] = useState(null);
  
  // Job detail popup state
  const [showJobPopup, setShowJobPopup] = useState(false);
  const [selectedJobId, setSelectedJobId] = useState(null);
  
  // Filter states
  const [filters, setFilters] = useState({
    startDate: '',
    endDate: '',
    cariHesap: '',
    sube: '',
    etiket: ''
  });
  
  // Dropdown data
  const [cariHesaplar, setCariHesaplar] = useState([]);
  const [hesapKartlari, setHesapKartlari] = useState([]);
  const [branches, setBranches] = useState([]);
  
  // Combobox states
  const [cariOpen, setCariOpen] = useState(false);
  const [etiketOpen, setEtiketOpen] = useState(false);
  
  // Form state
  const [form, setForm] = useState({
    olusturma_tarihi: '',
    cari_hesap_id: '',
    cari_hesap_adi: '',
    etiket_id: '',
    etiket_adi: '',
    fortis_sube_id: '',
    fortis_sube: '',
    aciklama: '',
    para_birimi: 'TL',  // TL, USD, EUR
    odeme_sayisi: 1,
    odemeler: [],
    fatura_miktari: ''  // Fatura miktarı
  });

  // Odeme form state
  const [odemeForm, setOdemeForm] = useState({
    odendi: true,
    odeme_tarihi: '',
    aciklama: ''
  });

  const fetchTakipler = useCallback(async () => {
    try {
      const token = localStorage.getItem('fortis_token');
      const response = await fetch(`${process.env.REACT_APP_BACKEND_URL}/api/accounting/takipler/${activeMainTab}`, {
        headers: { 'Authorization': `Bearer ${token}` }
      });
      if (response.ok) {
        const data = await response.json();
        setTakipler(data);
      }
    } catch (error) {
      console.error('Takipler alınamadı:', error);
    }
  }, [activeMainTab]);

  const fetchDropdownData = useCallback(async () => {
    try {
      const token = localStorage.getItem('fortis_token');
      const headers = { 'Authorization': `Bearer ${token}` };

      const [cariRes, etiketRes, branchRes] = await Promise.all([
        fetch(`${process.env.REACT_APP_BACKEND_URL}/api/accounting/cari-hesaplar`, { headers }),
        fetch(`${process.env.REACT_APP_BACKEND_URL}/api/accounting/hesap-kartlari`, { headers }),
        fetch(`${process.env.REACT_APP_BACKEND_URL}/api/branches`, { headers })
      ]);

      if (cariRes.ok) setCariHesaplar(await cariRes.json());
      if (etiketRes.ok) setHesapKartlari(await etiketRes.json());
      if (branchRes.ok) setBranches(await branchRes.json());
    } catch (error) {
      console.error('Dropdown verileri alınamadı:', error);
    }
  }, []);

  useEffect(() => {
    fetchTakipler();
    fetchDropdownData();
  }, [fetchTakipler, fetchDropdownData]);

  // İş referansı ile gelen işlemi kontrol et
  useEffect(() => {
    const pendingAction = localStorage.getItem('pending_job_action');
    if (pendingAction) {
      try {
        const action = JSON.parse(pendingAction);
        if (action.action_type === 'takip' || action.action_type === 'alacak' || action.action_type === 'borc') {
          setPendingJobAction(action);
          // Alacak/Borç sekmesini otomatik aç
          if (action.action_type === 'alacak') {
            setActiveMainTab('alacak');
          } else if (action.action_type === 'borc') {
            setActiveMainTab('borc');
          }
          // Formu aç
          setShowModal(true);
          // localStorage'dan sil
          localStorage.removeItem('pending_job_action');
          const actionLabel = action.action_type === 'alacak' ? 'alacak takibi' : action.action_type === 'borc' ? 'borç takibi' : 'takip kaydı';
          toast.info(`"${action.job_konu}" işi için ${actionLabel} ekleniyor`);
        }
      } catch (e) {
        console.error('Job action parse error:', e);
      }
    }
  }, []);

  // Filter takipler by status and filters
  const filteredTakipler = takipler.filter(t => {
    const matchesSearch = !searchTerm || 
      t.cari_hesap_adi?.toLowerCase().includes(searchTerm.toLowerCase()) ||
      t.etiket_adi?.toLowerCase().includes(searchTerm.toLowerCase()) ||
      t.fortis_sube?.toLowerCase().includes(searchTerm.toLowerCase());
    
    const matchesStatus = activeSubTab === 'devam' 
      ? t.durum === 'devam_ediyor' 
      : t.durum === 'tamamlandi';
    
    // Date filters
    let matchesDateRange = true;
    if (filters.startDate) {
      matchesDateRange = matchesDateRange && t.olusturma_tarihi >= filters.startDate;
    }
    if (filters.endDate) {
      matchesDateRange = matchesDateRange && t.olusturma_tarihi <= filters.endDate;
    }
    
    // Cari hesap filter
    const matchesCariHesap = !filters.cariHesap || 
      t.cari_hesap_adi?.toLowerCase().includes(filters.cariHesap.toLowerCase());
    
    // Sube filter
    const matchesSube = !filters.sube || filters.sube === 'all' || 
      t.fortis_sube_id === filters.sube;
    
    // Etiket filter
    const matchesEtiket = !filters.etiket || filters.etiket === 'all' || 
      t.etiket_id === filters.etiket;
    
    return matchesSearch && matchesStatus && matchesDateRange && matchesCariHesap && matchesSube && matchesEtiket;
  });

  // Sorting function
  const handleSort = (key) => {
    setSortConfig(prev => ({
      key,
      direction: prev.key === key && prev.direction === 'asc' ? 'desc' : 'asc'
    }));
  };

  // Sort icon component
  const SortIcon = ({ columnKey }) => {
    if (sortConfig.key !== columnKey) {
      return <ArrowUpDown className="h-3 w-3 ml-1 text-gray-400" />;
    }
    return sortConfig.direction === 'asc' 
      ? <ArrowUp className="h-3 w-3 ml-1 text-blue-600" />
      : <ArrowDown className="h-3 w-3 ml-1 text-blue-600" />;
  };

  // Sortable header component
  const SortableHeader = ({ children, columnKey, className = "" }) => (
    <TableHead 
      className={cn("cursor-pointer hover:bg-gray-100 select-none", className)}
      onClick={() => handleSort(columnKey)}
    >
      <div className="flex items-center">
        {children}
        <SortIcon columnKey={columnKey} />
      </div>
    </TableHead>
  );

  // Sort data
  const sortedTakipler = useMemo(() => {
    const sorted = [...filteredTakipler].sort((a, b) => {
      let aVal = a[sortConfig.key];
      let bVal = b[sortConfig.key];
      
      // Handle numeric values
      if (['toplam_tutar'].includes(sortConfig.key)) {
        aVal = parseFloat(aVal) || 0;
        bVal = parseFloat(bVal) || 0;
      }
      
      // Handle dates
      if (['olusturma_tarihi'].includes(sortConfig.key)) {
        aVal = new Date(aVal || 0).getTime();
        bVal = new Date(bVal || 0).getTime();
      }
      
      // Handle null/undefined
      if (aVal == null) aVal = '';
      if (bVal == null) bVal = '';
      
      if (aVal < bVal) return sortConfig.direction === 'asc' ? -1 : 1;
      if (aVal > bVal) return sortConfig.direction === 'asc' ? 1 : -1;
      return 0;
    });
    return sorted;
  }, [filteredTakipler, sortConfig]);

  // Clear filters
  const clearFilters = () => {
    setFilters({
      startDate: '',
      endDate: '',
      cariHesap: '',
      sube: '',
      etiket: ''
    });
  };

  // Export to Excel
  const exportToExcel = () => {
    const headers = ['Tarih', 'Cari Hesap', 'Şube', 'Etiket', 'Toplam Tutar', 'Ödeme Durumu', 'Durum'];
    const rows = filteredTakipler.map(t => [
      t.olusturma_tarihi || '',
      t.cari_hesap_adi || '',
      t.fortis_sube || '',
      t.etiket_adi || '',
      t.toplam_tutar || 0,
      `${t.odeme_durumu?.tamamlanan || 0}/${t.odeme_durumu?.toplam || 0}`,
      t.durum === 'tamamlandi' ? 'Tamamlandı' : 'Devam Ediyor'
    ]);
    
    const csvContent = [
      headers.join(','),
      ...rows.map(row => row.map(cell => `"${cell}"`).join(','))
    ].join('\n');
    
    const blob = new Blob(['\ufeff' + csvContent], { type: 'text/csv;charset=utf-8;' });
    const link = document.createElement('a');
    link.href = URL.createObjectURL(blob);
    link.download = `${activeMainTab === 'alacak' ? 'alacak' : 'borc'}_takip_${new Date().toISOString().split('T')[0]}.csv`;
    link.click();
    toast.success('Excel dosyası indirildi');
  };

  const openNewModal = () => {
    const now = new Date();
    setEditingTakip(null);
    setForm({
      olusturma_tarihi: now.toISOString().split('T')[0],
      cari_hesap_id: '',
      cari_hesap_adi: '',
      etiket_id: '',
      etiket_adi: '',
      fortis_sube_id: '',
      fortis_sube: '',
      aciklama: '',
      para_birimi: 'TL',
      belgeler: [],  // Çoklu belge desteği
      odeme_sayisi: 1,
      odemeler: [{ tarih: '', tutar: '', odeme_sekli: 'havale_eft', cek_resmi: null, aciklama: '' }],
      fatura_miktari: ''  // Fatura miktarı
    });
    setShowModal(true);
  };

  const openEditModal = (takip) => {
    setEditingTakip(takip);
    setForm({
      olusturma_tarihi: takip.olusturma_tarihi || '',
      cari_hesap_id: takip.cari_hesap_id || '',
      cari_hesap_adi: takip.cari_hesap_adi || '',
      etiket_id: takip.etiket_id || '',
      etiket_adi: takip.etiket_adi || '',
      fortis_sube_id: takip.fortis_sube_id || '',
      fortis_sube: takip.fortis_sube || '',
      aciklama: takip.aciklama || '',
      para_birimi: takip.para_birimi || 'TL',
      belgeler: takip.belgeler || [],  // Çoklu belge desteği
      odeme_sayisi: takip.odemeler?.length || 1,
      odemeler: takip.odemeler || [],
      fatura_miktari: takip.fatura_miktari || ''  // Fatura miktarı
    });
    setShowModal(true);
  };

  const handleOdemeSayisiChange = (sayi) => {
    const newSayi = parseInt(sayi) || 1;
    const currentOdemeler = [...form.odemeler];
    
    if (newSayi > currentOdemeler.length) {
      // Add more payment slots
      for (let i = currentOdemeler.length; i < newSayi; i++) {
        currentOdemeler.push({ tarih: '', tutar: '', odeme_sekli: 'havale_eft', cek_resmi: null, aciklama: '' });
      }
    } else if (newSayi < currentOdemeler.length) {
      // Remove payment slots
      currentOdemeler.splice(newSayi);
    }
    
    setForm({ ...form, odeme_sayisi: newSayi, odemeler: currentOdemeler });
  };

  const handleOdemeChange = (index, field, value) => {
    const newOdemeler = [...form.odemeler];
    newOdemeler[index] = { ...newOdemeler[index], [field]: value };
    setForm({ ...form, odemeler: newOdemeler });
  };

  const handleCekImageUpload = (index, e) => {
    const file = e.target.files[0];
    if (!file) return;

    const reader = new FileReader();
    reader.onload = (event) => {
      const newOdemeler = [...form.odemeler];
      newOdemeler[index] = { ...newOdemeler[index], cek_resmi: event.target.result };
      setForm({ ...form, odemeler: newOdemeler });
      toast.success('Çek resmi eklendi');
    };
    reader.readAsDataURL(file);
  };

  // Çoklu belge yükleme
  const handleFileUpload = async (e) => {
    const files = Array.from(e.target.files);
    if (!files.length) return;

    const newBelgeler = [];
    for (const file of files) {
      const reader = new FileReader();
      const fileData = await new Promise((resolve) => {
        reader.onload = (event) => {
          resolve({
            url: event.target.result,
            name: file.name
          });
        };
        reader.readAsDataURL(file);
      });
      newBelgeler.push(fileData);
    }
    
    setForm(prev => ({
      ...prev,
      belgeler: [...prev.belgeler, ...newBelgeler]
    }));
    toast.success(`${files.length} belge eklendi`);
    e.target.value = '';
  };

  const removeBelge = (index) => {
    setForm(prev => ({
      ...prev,
      belgeler: prev.belgeler.filter((_, i) => i !== index)
    }));
  };

  const handleSubmit = async () => {
    if (!form.cari_hesap_id) {
      toast.error('Cari hesap seçiniz');
      return;
    }

    // Fatura miktarı zorunlu kontrolü
    if (!form.fatura_miktari || parseFloat(form.fatura_miktari) <= 0) {
      toast.error(activeMainTab === 'alacak' ? 'Kesilecek fatura miktarı giriniz' : 'Alınan fatura miktarı giriniz');
      return;
    }

    const validOdemeler = form.odemeler.filter(o => o.tarih && o.tutar);
    if (validOdemeler.length === 0) {
      toast.error('En az bir ödeme planı giriniz');
      return;
    }

    try {
      const token = localStorage.getItem('fortis_token');
      const url = editingTakip
        ? `${process.env.REACT_APP_BACKEND_URL}/api/accounting/takipler/${activeMainTab}/${editingTakip.id}`
        : `${process.env.REACT_APP_BACKEND_URL}/api/accounting/takipler/${activeMainTab}`;

      // İş referansı ve fatura miktarı ekle
      let formData = {
        ...form,
        odemeler: validOdemeler,
        fatura_miktari: parseFloat(form.fatura_miktari) || 0
      };
      
      if (pendingJobAction && !editingTakip) {
        formData.job_id = pendingJobAction.job_id;
        formData.job_konu = pendingJobAction.job_konu;
      }

      // ONAYLANAN İŞ AKIŞI: Gerçek kaydı YAZMA! Sadece Taslak (pending_transaction) olarak ekle.
      // Gerçek Alacak/Borç kaydı, Yönetim Kurulu onayladıktan sonra oluşturulacak.
      if (pendingJobAction && !editingTakip) {
        try {
          const txType = activeMainTab === 'alacak' ? 'alacak' : 'borc';
          const pendingPayload = {
            type: txType,
            tarih: formData.tarih,
            tutar: parseFloat(formData.fatura_miktari) || 0,
            toplam_tutar: parseFloat(formData.fatura_miktari) || 0,
            para_birimi: formData.para_birimi || 'TL',
            cari_hesap_id: formData.cari_hesap_id || null,
            cari_hesap_adi: formData.cari_hesap_adi || '',
            aciklama: formData.aciklama || '',
            odemeler: validOdemeler,
            form_data: { ...formData }
          };
          const pendingRes = await fetch(
            `${process.env.REACT_APP_BACKEND_URL}/api/accounting/isler/${pendingJobAction.job_id}/pending-transactions`,
            {
              method: 'POST',
              headers: { 'Content-Type': 'application/json', 'Authorization': `Bearer ${token}` },
              body: JSON.stringify(pendingPayload)
            }
          );
          if (!pendingRes.ok) {
            const err = await pendingRes.json().catch(() => ({}));
            toast.error(err.detail || 'Taslak işlem eklenemedi');
            return;
          }
          await fetch(
            `${process.env.REACT_APP_BACKEND_URL}/api/accounting/isler/${pendingJobAction.job_id}/complete-approved`,
            {
              method: 'PUT',
              headers: { 'Content-Type': 'application/json', 'Authorization': `Bearer ${token}` },
              body: JSON.stringify({ note: `${activeMainTab === 'alacak' ? 'Alacak' : 'Borç'} kaydı taslak olarak eklendi` })
            }
          );
          toast.success(`"${pendingJobAction.job_konu}" işi için ${activeMainTab === 'alacak' ? 'alacak' : 'borç'} taslağı oluşturuldu ve Yönetim Kurulu onayına gönderildi`);
          setPendingJobAction(null);
          localStorage.removeItem('pending_job_action');
          setShowModal(false);
          navigate('/accounting/jobs');
          return;
        } catch (e) {
          console.error('Taslak takip ekleme hatası:', e);
          toast.error('Taslak takip eklenemedi');
          return;
        }
      }

      const response = await fetch(url, {
        method: editingTakip ? 'PUT' : 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${token}`
        },
        body: JSON.stringify(formData)
      });

      if (response.ok) {
        toast.success(editingTakip ? 'Takip güncellendi' : `${activeMainTab === 'alacak' ? 'Alacak' : 'Borç'} takip eklendi`);
        
        // Fatura kaydı bilgilendirmesi
        if (!editingTakip && form.fatura_miktari) {
          toast.info(
            activeMainTab === 'alacak' 
              ? `${form.cari_hesap_adi} için ${formatCurrency(form.fatura_miktari, form.para_birimi)} kesilmesi gereken fatura kaydedildi`
              : `${form.cari_hesap_adi} için ${formatCurrency(form.fatura_miktari, form.para_birimi)} alınması gereken fatura kaydedildi`
          );
        }
        
        setShowModal(false);
        fetchTakipler();
      } else {
        toast.error('İşlem başarısız');
      }
    } catch (error) {
      toast.error('Bir hata oluştu');
    }
  };

  const handleDelete = async (id) => {
    if (!window.confirm('Bu takip kaydını silmek istediğinizden emin misiniz?')) return;

    try {
      const token = localStorage.getItem('fortis_token');
      const response = await fetch(`${process.env.REACT_APP_BACKEND_URL}/api/accounting/takipler/${activeMainTab}/${id}`, {
        method: 'DELETE',
        headers: { 'Authorization': `Bearer ${token}` }
      });

      if (response.ok) {
        toast.success('Takip kaydı silindi');
        fetchTakipler();
      }
    } catch (error) {
      toast.error('Silme işlemi başarısız');
    }
  };

  const openDetailModal = (takip) => {
    setSelectedTakip(takip);
    setShowDetailModal(true);
  };

  const openOdemeModal = (takip, odeme) => {
    setSelectedTakip(takip);
    setSelectedOdeme(odeme);
    setOdemeForm({
      odendi: true,
      odeme_tarihi: new Date().toISOString().split('T')[0],
      aciklama: ''
    });
    setShowOdemeModal(true);
  };

  const handleMarkOdemePaid = async () => {
    try {
      const token = localStorage.getItem('fortis_token');
      const response = await fetch(
        `${process.env.REACT_APP_BACKEND_URL}/api/accounting/takipler/${activeMainTab}/${selectedTakip.id}/odeme/${selectedOdeme.id}`,
        {
          method: 'PUT',
          headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${token}`
          },
          body: JSON.stringify(odemeForm)
        }
      );

      if (response.ok) {
        const result = await response.json();
        toast.success('Ödeme tamamlandı olarak işaretlendi');
        if (result.tamamlandi) {
          toast.success('Tüm ödemeler tamamlandı!');
        }
        setShowOdemeModal(false);
        fetchTakipler();
      }
    } catch (error) {
      toast.error('Bir hata oluştu');
    }
  };

  const formatCurrency = (amount, currency = 'TL') => {
    const currencyMap = {
      'TL': 'TRY',
      'USD': 'USD',
      'EUR': 'EUR'
    };
    return new Intl.NumberFormat('tr-TR', {
      style: 'currency',
      currency: currencyMap[currency] || 'TRY'
    }).format(amount || 0);
  };

  const getCurrencySymbol = (currency) => {
    const symbols = { 'TL': '₺', 'USD': '$', 'EUR': '€' };
    return symbols[currency] || '₺';
  };

  const getOdemeSekliIcon = (sekil) => {
    switch (sekil) {
      case 'havale_eft': return <Banknote className="h-4 w-4" />;
      case 'cek': return <FileText className="h-4 w-4" />;
      case 'nakit': return <CreditCard className="h-4 w-4" />;
      default: return <Banknote className="h-4 w-4" />;
    }
  };

  const getOdemeSekliLabel = (sekil) => {
    switch (sekil) {
      case 'havale_eft': return 'Havale/EFT';
      case 'cek': return 'Çek';
      case 'nakit': return 'Nakit';
      default: return sekil;
    }
  };

  // Statistics
  const devamEdenler = takipler.filter(t => t.durum === 'devam_ediyor');
  const tamamlananlar = takipler.filter(t => t.durum === 'tamamlandi');
  const toplamTutar = takipler.reduce((sum, t) => sum + (parseFloat(t.toplam_tutar) || 0), 0);
  
  // Vade hesaplamaları
  const vadesiGecenIslemler = useMemo(() => {
    const today = new Date();
    today.setHours(0, 0, 0, 0);
    return devamEdenler.filter(t => {
      if (!t.odemeler) return false;
      return t.odemeler.some(o => {
        if (o.odendi || !o.tarih) return false;
        const vadeTarihi = new Date(o.tarih);
        vadeTarihi.setHours(0, 0, 0, 0);
        return vadeTarihi < today;
      });
    });
  }, [devamEdenler]);

  const birHaftaKalanIslemler = useMemo(() => {
    const today = new Date();
    today.setHours(0, 0, 0, 0);
    const nextWeek = new Date(today);
    nextWeek.setDate(today.getDate() + 7);
    
    return devamEdenler.filter(t => {
      if (!t.odemeler) return false;
      return t.odemeler.some(o => {
        if (o.odendi || !o.tarih) return false;
        const vadeTarihi = new Date(o.tarih);
        vadeTarihi.setHours(0, 0, 0, 0);
        return vadeTarihi >= today && vadeTarihi <= nextWeek;
      });
    });
  }, [devamEdenler]);

  const vadesiGecenTutar = useMemo(() => {
    const today = new Date();
    today.setHours(0, 0, 0, 0);
    let total = 0;
    devamEdenler.forEach(t => {
      t.odemeler?.forEach(o => {
        const tutar = parseFloat(o.tutar) || 0;
        const odenen = parseFloat(o.odenen_tutar) || 0;
        const kalan = Math.max(0, tutar - odenen);
        if (kalan > 0 && o.tarih) {
          const vadeTarihi = new Date(o.tarih);
          vadeTarihi.setHours(0, 0, 0, 0);
          if (vadeTarihi < today) {
            total += kalan;
          }
        }
      });
    });
    return total;
  }, [devamEdenler]);

  const birHaftaKalanTutar = useMemo(() => {
    const today = new Date();
    today.setHours(0, 0, 0, 0);
    const nextWeek = new Date(today);
    nextWeek.setDate(today.getDate() + 7);
    nextWeek.setHours(23, 59, 59, 999);
    let total = 0;
    devamEdenler.forEach(t => {
      t.odemeler?.forEach(o => {
        const tutar = parseFloat(o.tutar) || 0;
        const odenen = parseFloat(o.odenen_tutar) || 0;
        const kalan = Math.max(0, tutar - odenen);
        if (kalan > 0 && o.tarih) {
          const vadeTarihi = new Date(o.tarih);
          vadeTarihi.setHours(0, 0, 0, 0);
          if (vadeTarihi >= today && vadeTarihi <= nextWeek) {
            total += kalan;
          }
        }
      });
    });
    return total;
  }, [devamEdenler]);

  // Calculate totals by currency with paid and remaining amounts
  const totalsByCurrency = useMemo(() => {
    const totals = { 
      TL: { toplam: 0, odenen: 0, kalan: 0 }, 
      USD: { toplam: 0, odenen: 0, kalan: 0 }, 
      EUR: { toplam: 0, odenen: 0, kalan: 0 } 
    };
    takipler.forEach(t => {
      const currency = t.para_birimi || 'TL';
      if (!totals[currency]) {
        totals[currency] = { toplam: 0, odenen: 0, kalan: 0 };
      }
      const toplamTakip = parseFloat(t.toplam_tutar) || 0;
      totals[currency].toplam += toplamTakip;
      
      // Her taksit için ödenen ve kalan hesapla
      const odemeler = t.odemeler || [];
      odemeler.forEach(odeme => {
        const tutar = parseFloat(odeme.tutar) || 0;
        const odenenTutar = parseFloat(odeme.odenen_tutar) || 0;
        // Ödenen tutar, taksit tutarını aşamaz
        const gercekOdenen = Math.min(odenenTutar, tutar);
        const kalanTutar = Math.max(0, tutar - gercekOdenen);
        totals[currency].odenen += gercekOdenen;
        totals[currency].kalan += kalanTutar;
      });
    });
    return totals;
  }, [takipler]);

  return (
    <div className="space-y-6" data-testid="accounting-takipler">
      <div className="flex items-center justify-between">
        <div>
          <h1 className="text-2xl font-bold text-gray-900">Takipler</h1>
          <p className="text-gray-500">Alacak ve borç takip yönetimi</p>
        </div>
      </div>

      {/* Main Tabs: Alacak / Borç */}
      <Tabs value={activeMainTab} onValueChange={(v) => { setActiveMainTab(v); setActiveSubTab('devam'); }} className="w-full">
        <TabsList className="grid w-full max-w-md grid-cols-2">
          <TabsTrigger value="alacak" className="gap-2" data-testid="alacak-tab">
            <TrendingUp className="h-4 w-4" />
            Alacak Takip
          </TabsTrigger>
          <TabsTrigger value="borc" className="gap-2" data-testid="borc-tab">
            <TrendingDown className="h-4 w-4" />
            Borç Takip
          </TabsTrigger>
        </TabsList>

        <TabsContent value={activeMainTab} className="mt-6">
          {/* Statistics Cards */}
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-5 gap-4 mb-6">
            <Card className={`bg-gradient-to-br ${activeMainTab === 'alacak' ? 'from-green-50 to-green-100 border-green-200' : 'from-red-50 to-red-100 border-red-200'}`}>
              <CardContent className="pt-4 pb-3">
                <div className="flex items-center gap-3">
                  <div className={`p-2 ${activeMainTab === 'alacak' ? 'bg-green-500' : 'bg-red-500'} rounded-lg`}>
                    {activeMainTab === 'alacak' ? <TrendingUp className="h-5 w-5 text-white" /> : <TrendingDown className="h-5 w-5 text-white" />}
                  </div>
                  <div className="flex-1">
                    <p className={`text-xs ${activeMainTab === 'alacak' ? 'text-green-600' : 'text-red-600'} font-medium`}>
                      Toplam TL
                    </p>
                    <p className={`text-xl font-bold ${activeMainTab === 'alacak' ? 'text-green-900' : 'text-red-900'}`}>
                      {formatCurrency(totalsByCurrency.TL?.toplam || 0, 'TL')}
                    </p>
                  </div>
                </div>
                <div className="mt-2 pt-2 border-t border-gray-200 grid grid-cols-2 gap-2 text-xs">
                  <div>
                    <span className="text-gray-500">Ödenen:</span>
                    <span className="ml-1 font-semibold text-green-600">{formatCurrency(totalsByCurrency.TL?.odenen || 0, 'TL')}</span>
                  </div>
                  <div>
                    <span className="text-gray-500">Kalan:</span>
                    <span className={`ml-1 font-semibold ${(totalsByCurrency.TL?.kalan || 0) > 0 ? 'text-red-600' : 'text-gray-400'}`}>
                      {formatCurrency(totalsByCurrency.TL?.kalan || 0, 'TL')}
                    </span>
                  </div>
                </div>
              </CardContent>
            </Card>
            {(totalsByCurrency.USD?.toplam || 0) > 0 && (
              <Card className="bg-gradient-to-br from-blue-50 to-blue-100 border-blue-200">
                <CardContent className="pt-4 pb-3">
                  <div className="flex items-center gap-3">
                    <div className="p-2 bg-blue-500 rounded-lg">
                      {activeMainTab === 'alacak' ? <TrendingUp className="h-5 w-5 text-white" /> : <TrendingDown className="h-5 w-5 text-white" />}
                    </div>
                    <div className="flex-1">
                      <p className="text-xs text-blue-600 font-medium">Toplam USD</p>
                      <p className="text-xl font-bold text-blue-900">{formatCurrency(totalsByCurrency.USD?.toplam || 0, 'USD')}</p>
                    </div>
                  </div>
                  <div className="mt-2 pt-2 border-t border-gray-200 grid grid-cols-2 gap-2 text-xs">
                    <div>
                      <span className="text-gray-500">Ödenen:</span>
                      <span className="ml-1 font-semibold text-green-600">{formatCurrency(totalsByCurrency.USD?.odenen || 0, 'USD')}</span>
                    </div>
                    <div>
                      <span className="text-gray-500">Kalan:</span>
                      <span className={`ml-1 font-semibold ${(totalsByCurrency.USD?.kalan || 0) > 0 ? 'text-red-600' : 'text-gray-400'}`}>
                        {formatCurrency(totalsByCurrency.USD?.kalan || 0, 'USD')}
                      </span>
                    </div>
                  </div>
                </CardContent>
              </Card>
            )}
            {(totalsByCurrency.EUR?.toplam || 0) > 0 && (
              <Card className="bg-gradient-to-br from-purple-50 to-purple-100 border-purple-200">
                <CardContent className="pt-4 pb-3">
                  <div className="flex items-center gap-3">
                    <div className="p-2 bg-purple-500 rounded-lg">
                      {activeMainTab === 'alacak' ? <TrendingUp className="h-5 w-5 text-white" /> : <TrendingDown className="h-5 w-5 text-white" />}
                    </div>
                    <div className="flex-1">
                      <p className="text-xs text-purple-600 font-medium">Toplam EUR</p>
                      <p className="text-xl font-bold text-purple-900">{formatCurrency(totalsByCurrency.EUR?.toplam || 0, 'EUR')}</p>
                    </div>
                  </div>
                  <div className="mt-2 pt-2 border-t border-gray-200 grid grid-cols-2 gap-2 text-xs">
                    <div>
                      <span className="text-gray-500">Ödenen:</span>
                      <span className="ml-1 font-semibold text-green-600">{formatCurrency(totalsByCurrency.EUR?.odenen || 0, 'EUR')}</span>
                    </div>
                    <div>
                      <span className="text-gray-500">Kalan:</span>
                      <span className={`ml-1 font-semibold ${(totalsByCurrency.EUR?.kalan || 0) > 0 ? 'text-red-600' : 'text-gray-400'}`}>
                        {formatCurrency(totalsByCurrency.EUR?.kalan || 0, 'EUR')}
                      </span>
                    </div>
                  </div>
                </CardContent>
              </Card>
            )}
            <Card className="bg-gradient-to-br from-amber-50 to-amber-100 border-amber-200">
              <CardContent className="pt-6">
                <div className="flex items-center gap-4">
                  <div className="p-3 bg-amber-500 rounded-lg">
                    <Clock className="h-6 w-6 text-white" />
                  </div>
                  <div>
                    <p className="text-sm text-amber-600 font-medium">Devam Eden</p>
                    <p className="text-2xl font-bold text-amber-900">{devamEdenler.length}</p>
                  </div>
                </div>
              </CardContent>
            </Card>
            <Card className="bg-gradient-to-br from-red-50 to-red-100 border-red-200">
              <CardContent className="pt-6">
                <div className="flex items-center gap-4">
                  <div className="p-3 bg-red-500 rounded-lg">
                    <AlertTriangle className="h-6 w-6 text-white" />
                  </div>
                  <div>
                    <p className="text-sm text-red-600 font-medium">Vadesi Geçen</p>
                    <p className="text-2xl font-bold text-red-900">
                      {vadesiGecenIslemler.length}
                      <span className="text-sm font-normal text-red-700 ml-2">işlem</span>
                    </p>
                    <p className="text-sm font-semibold text-red-700 mt-1">{formatCurrency(vadesiGecenTutar, 'TL')}</p>
                  </div>
                </div>
              </CardContent>
            </Card>
            <Card className="bg-gradient-to-br from-orange-50 to-orange-100 border-orange-200">
              <CardContent className="pt-6">
                <div className="flex items-center gap-4">
                  <div className="p-3 bg-orange-500 rounded-lg">
                    <CalendarClock className="h-6 w-6 text-white" />
                  </div>
                  <div>
                    <p className="text-sm text-orange-600 font-medium">Bu Hafta Ödenecek</p>
                    <p className="text-2xl font-bold text-orange-900">
                      {birHaftaKalanIslemler.length}
                      <span className="text-sm font-normal text-orange-700 ml-2">işlem</span>
                    </p>
                    <p className="text-sm font-semibold text-orange-700 mt-1">{formatCurrency(birHaftaKalanTutar, 'TL')}</p>
                  </div>
                </div>
              </CardContent>
            </Card>
            <Card className="bg-gradient-to-br from-emerald-50 to-emerald-100 border-emerald-200">
              <CardContent className="pt-6">
                <div className="flex items-center gap-4">
                  <div className="p-3 bg-emerald-500 rounded-lg">
                    <CheckCircle className="h-6 w-6 text-white" />
                  </div>
                  <div>
                    <p className="text-sm text-emerald-600 font-medium">Tamamlanan</p>
                    <p className="text-2xl font-bold text-emerald-900">{tamamlananlar.length}</p>
                  </div>
                </div>
              </CardContent>
            </Card>
          </div>

          {/* Action Buttons */}
          <div className="flex justify-between items-center mb-4">
            <div className="flex gap-2">
              <Button
                variant="outline"
                onClick={() => setShowFilters(!showFilters)}
                className="gap-2"
                data-testid="toggle-filters-btn"
              >
                <Filter className="h-4 w-4" />
                Filtrele
                <ChevronDown className={`h-4 w-4 transition-transform ${showFilters ? 'rotate-180' : ''}`} />
              </Button>
              <Button
                variant="outline"
                onClick={exportToExcel}
                className="gap-2"
                data-testid="export-excel-btn"
              >
                <Download className="h-4 w-4" />
                Excel İndir
              </Button>
            </div>
            <Button
              onClick={openNewModal}
              className={`gap-2 ${activeMainTab === 'alacak' ? 'bg-green-600 hover:bg-green-700' : 'bg-red-600 hover:bg-red-700'}`}
              data-testid="add-takip-btn"
            >
              <Plus className="h-4 w-4" />
              {activeMainTab === 'alacak' ? 'Alacak Ekle' : 'Borç Ekle'}
            </Button>
          </div>

          {/* Filter Panel */}
          <Collapsible open={showFilters} onOpenChange={setShowFilters}>
            <CollapsibleContent>
              <Card className="mb-4 border-dashed">
                <CardContent className="pt-4">
                  <div className="grid grid-cols-1 md:grid-cols-5 gap-4">
                    <div className="space-y-2">
                      <Label className="text-xs">Başlangıç Tarihi</Label>
                      <Input
                        type="date"
                        value={filters.startDate}
                        onChange={(e) => setFilters({ ...filters, startDate: e.target.value })}
                        data-testid="filter-start-date"
                      />
                    </div>
                    <div className="space-y-2">
                      <Label className="text-xs">Bitiş Tarihi</Label>
                      <Input
                        type="date"
                        value={filters.endDate}
                        onChange={(e) => setFilters({ ...filters, endDate: e.target.value })}
                        data-testid="filter-end-date"
                      />
                    </div>
                    <div className="space-y-2">
                      <Label className="text-xs">Cari Hesap</Label>
                      <Input
                        placeholder="Cari hesap ara..."
                        value={filters.cariHesap}
                        onChange={(e) => setFilters({ ...filters, cariHesap: e.target.value })}
                        data-testid="filter-cari-hesap"
                      />
                    </div>
                    <div className="space-y-2">
                      <Label className="text-xs">Şube</Label>
                      <Select value={filters.sube} onValueChange={(v) => setFilters({ ...filters, sube: v })}>
                        <SelectTrigger data-testid="filter-sube">
                          <SelectValue placeholder="Tümü" />
                        </SelectTrigger>
                        <SelectContent>
                          <SelectItem value="all">Tümü</SelectItem>
                          {branches.map((branch) => (
                            <SelectItem key={branch.id} value={branch.id}>{branch.name}</SelectItem>
                          ))}
                        </SelectContent>
                      </Select>
                    </div>
                    <div className="space-y-2">
                      <Label className="text-xs">Etiket</Label>
                      <Select value={filters.etiket} onValueChange={(v) => setFilters({ ...filters, etiket: v })}>
                        <SelectTrigger data-testid="filter-etiket">
                          <SelectValue placeholder="Tümü" />
                        </SelectTrigger>
                        <SelectContent>
                          <SelectItem value="all">Tümü</SelectItem>
                          {hesapKartlari.map((etiket) => (
                            <SelectItem key={etiket.id} value={etiket.id}>{etiket.kayit_adi}</SelectItem>
                          ))}
                        </SelectContent>
                      </Select>
                    </div>
                  </div>
                  <div className="mt-4 flex justify-end">
                    <Button variant="ghost" onClick={clearFilters} className="text-gray-500">
                      Filtreleri Temizle
                    </Button>
                  </div>
                </CardContent>
              </Card>
            </CollapsibleContent>
          </Collapsible>

          {/* Sub Tabs: Devam Eden / Bitirilen */}
          <Tabs value={activeSubTab} onValueChange={setActiveSubTab} className="w-full">
            <TabsList className="grid w-full max-w-md grid-cols-2">
              <TabsTrigger value="devam" className="gap-2" data-testid="devam-tab">
                <Clock className="h-4 w-4" />
                Devam Eden Ödemeler
                {devamEdenler.length > 0 && (
                  <Badge variant="secondary" className="ml-1">{devamEdenler.length}</Badge>
                )}
              </TabsTrigger>
              <TabsTrigger value="biten" className="gap-2" data-testid="biten-tab">
                <CheckCircle className="h-4 w-4" />
                Bitirilen Ödemeler
                {tamamlananlar.length > 0 && (
                  <Badge variant="secondary" className="ml-1">{tamamlananlar.length}</Badge>
                )}
              </TabsTrigger>
            </TabsList>

            <TabsContent value={activeSubTab} className="mt-4">
              <Card>
                <CardHeader>
                  <div className="flex items-center justify-between">
                    <CardTitle className="flex items-center gap-2">
                      {activeMainTab === 'alacak' ? (
                        <TrendingUp className="h-5 w-5 text-green-600" />
                      ) : (
                        <TrendingDown className="h-5 w-5 text-red-600" />
                      )}
                      {activeSubTab === 'devam' ? 'Devam Eden Ödemeler' : 'Bitirilen Ödemeler'}
                    </CardTitle>
                  </div>
                </CardHeader>
                <CardContent>
                  {/* Search */}
                  <div className="relative mb-4">
                    <Search className="absolute left-3 top-1/2 transform -translate-y-1/2 h-4 w-4 text-gray-400" />
                    <Input
                      placeholder="Cari hesap veya etiket ara..."
                      value={searchTerm}
                      onChange={(e) => setSearchTerm(e.target.value)}
                      className="pl-10"
                      data-testid="takip-search"
                    />
                  </div>

                  {/* Table */}
                  <div className="rounded-lg border overflow-hidden">
                    <Table>
                      <TableHeader>
                        <TableRow className="bg-gray-50">
                          <SortableHeader columnKey="seri_no">Seri No</SortableHeader>
                          <SortableHeader columnKey="olusturma_tarihi">Tarih</SortableHeader>
                          <SortableHeader columnKey="cari_hesap_adi">Cari Hesap</SortableHeader>
                          <SortableHeader columnKey="fortis_sube">Şube</SortableHeader>
                          <SortableHeader columnKey="etiket_adi">Etiket</SortableHeader>
                          <SortableHeader columnKey="toplam_tutar">Toplam Tutar</SortableHeader>
                          <TableHead className="text-red-600">{activeMainTab === 'alacak' ? 'Vadesi Geçen Alacak' : 'Vadesi Geçen Ödeme'}</TableHead>
                          <TableHead>Ödeme Durumu</TableHead>
                          <TableHead>Belgeler</TableHead>
                          <SortableHeader columnKey="aciklama">Açıklama</SortableHeader>
                          <TableHead className="text-center">İş Kaydı</TableHead>
                          <TableHead className="text-right">Detay</TableHead>
                        </TableRow>
                      </TableHeader>
                      <TableBody>
                        {sortedTakipler.length === 0 ? (
                          <TableRow>
                            <TableCell colSpan={12} className="text-center py-8 text-gray-500">
                              {activeSubTab === 'devam' ? 'Devam eden ödeme bulunamadı' : 'Bitirilen ödeme bulunamadı'}
                            </TableCell>
                          </TableRow>
                        ) : (
                          sortedTakipler.map((takip) => (
                            <TableRow key={takip.id} data-testid={`takip-row-${takip.id}`}>
                              <TableCell className="font-mono text-sm text-gray-600">
                                {takip.seri_no || '-'}
                              </TableCell>
                              <TableCell className="font-medium">
                                {takip.olusturma_tarihi}
                              </TableCell>
                              <TableCell>{takip.cari_hesap_adi || '-'}</TableCell>
                              <TableCell>
                                {takip.fortis_sube ? (
                                  <Badge variant="secondary" className="text-xs">{takip.fortis_sube}</Badge>
                                ) : '-'}
                              </TableCell>
                              <TableCell>
                                {takip.etiket_adi && (
                                  <Badge variant="outline">{takip.etiket_adi}</Badge>
                                )}
                              </TableCell>
                              <TableCell className={`font-semibold ${activeMainTab === 'alacak' ? 'text-green-600' : 'text-red-600'}`}>
                                {formatCurrency(takip.toplam_tutar, takip.para_birimi || 'TL')}
                              </TableCell>
                              {/* Vadesi Geçen Alacak/Ödeme */}
                              <TableCell>
                                {(() => {
                                  const today = new Date();
                                  today.setHours(0, 0, 0, 0);
                                  let vadesiGecenToplam = 0;
                                  
                                  takip.odemeler?.forEach(odeme => {
                                    const vadeTarihi = new Date(odeme.tarih);
                                    vadeTarihi.setHours(0, 0, 0, 0);
                                    const tutar = parseFloat(odeme.tutar) || 0;
                                    const odenenTutar = parseFloat(odeme.odenen_tutar) || 0;
                                    const kalanTutar = Math.max(0, tutar - odenenTutar);
                                    
                                    // Vadesi geçmiş ve hala ödenmemiş kalan varsa
                                    if (vadeTarihi < today && kalanTutar > 0) {
                                      vadesiGecenToplam += kalanTutar;
                                    }
                                  });
                                  
                                  return vadesiGecenToplam > 0 ? (
                                    <span className="font-semibold text-red-600 bg-red-50 px-2 py-1 rounded">
                                      {formatCurrency(vadesiGecenToplam, takip.para_birimi || 'TL')}
                                    </span>
                                  ) : (
                                    <span className="text-gray-400">-</span>
                                  );
                                })()}
                              </TableCell>
                              <TableCell>
                                <div className="space-y-2">
                                  {takip.odemeler?.map((odeme, idx) => {
                                    const tutar = parseFloat(odeme.tutar) || 0;
                                    const odenenTutar = Math.min(parseFloat(odeme.odenen_tutar) || 0, tutar);
                                    const kalanTutar = Math.max(0, tutar - odenenTutar);
                                    const tamOdendi = kalanTutar <= 0;
                                    
                                    return (
                                      <div key={odeme.id || idx} className={`p-2 rounded-lg border ${tamOdendi ? 'bg-green-50 border-green-200' : odenenTutar > 0 ? 'bg-blue-50 border-blue-200' : 'bg-gray-50 border-gray-200'}`}>
                                        {/* Taksit başlığı */}
                                        <div className="flex items-center justify-between text-sm font-medium mb-1">
                                          <span className={tamOdendi ? 'text-green-700' : 'text-gray-700'}>
                                            {tamOdendi && '✓ '}{idx + 1}. Taksit
                                          </span>
                                          <span className="text-gray-600">{formatCurrency(tutar)}</span>
                                        </div>
                                        
                                        {/* Vade tarihi */}
                                        <div className="text-xs text-gray-500 mb-1">
                                          Vade: {odeme.tarih}
                                        </div>
                                        
                                        {/* Ödeme geçmişi */}
                                        {odeme.odeme_gecmisi && odeme.odeme_gecmisi.length > 0 && (
                                          <div className="mt-2 pt-2 border-t border-gray-200 space-y-1">
                                            {odeme.odeme_gecmisi.map((gecmis, gIdx) => (
                                              <div key={gIdx} className="flex justify-between text-xs">
                                                <span className="text-green-600">
                                                  • Ödeme {gIdx + 1}: {formatCurrency(gecmis.tutar)}
                                                </span>
                                                <span className="text-gray-500">{gecmis.tarih}</span>
                                              </div>
                                            ))}
                                            {/* Fazla ödeme uyarısı */}
                                            {parseFloat(odeme.odenen_tutar) > tutar && (
                                              <div className="text-xs text-amber-600 mt-1">
                                                ⚠️ Fazla ödeme: {formatCurrency(parseFloat(odeme.odenen_tutar) - tutar)}
                                              </div>
                                            )}
                                          </div>
                                        )}
                                        
                                        {/* Özet satırı */}
                                        <div className="flex justify-between items-center mt-2 pt-2 border-t border-gray-200 text-xs font-medium">
                                          <span className="text-green-600">
                                            Ödenen: {formatCurrency(odenenTutar)}
                                          </span>
                                          <span className={kalanTutar > 0 ? 'text-red-600' : 'text-green-600'}>
                                            Kalan: {formatCurrency(kalanTutar)}
                                          </span>
                                        </div>
                                      </div>
                                    );
                                  })}
                                </div>
                              </TableCell>
                              <TableCell>
                                {takip.belgeler && takip.belgeler.length > 0 ? (
                                  <button
                                    onClick={() => {
                                      setPreviewBelgeler(takip.belgeler);
                                      setShowDocPreview(true);
                                    }}
                                    className="flex items-center gap-1 cursor-pointer hover:underline"
                                    data-testid={`belgeler-link-${takip.id}`}
                                  >
                                    <FileText className="h-4 w-4 text-blue-600" />
                                    <span className="text-xs text-blue-600">{takip.belgeler.length} belge</span>
                                  </button>
                                ) : '-'}
                              </TableCell>
                              <TableCell>
                                <span className="text-xs text-gray-600 max-w-[150px] truncate block" title={takip.aciklama}>
                                  {takip.aciklama || '-'}
                                </span>
                              </TableCell>
                              <TableCell className="text-center">
                                {takip.job_id ? (
                                  <Button
                                    variant="ghost"
                                    size="sm"
                                    onClick={() => {
                                      setSelectedJobId(takip.job_id);
                                      setShowJobPopup(true);
                                    }}
                                    className="text-indigo-600 hover:text-indigo-800 hover:bg-indigo-50"
                                    title="İş Kaydını Görüntüle"
                                  >
                                    <Briefcase className="h-4 w-4" />
                                  </Button>
                                ) : (
                                  <span className="text-gray-300">-</span>
                                )}
                              </TableCell>
                              <TableCell className="text-right">
                                <Button
                                  variant="ghost"
                                  size="sm"
                                  onClick={() => openDetailModal(takip)}
                                  title="Detay"
                                >
                                  <Eye className="h-4 w-4" />
                                </Button>
                              </TableCell>
                            </TableRow>
                          ))
                        )}
                      </TableBody>
                    </Table>
                  </div>
                </CardContent>
              </Card>
            </TabsContent>
          </Tabs>
        </TabsContent>
      </Tabs>

      {/* Add/Edit Modal */}
      <Dialog open={showModal} onOpenChange={setShowModal}>
        <DialogContent className="sm:max-w-[700px] max-h-[90vh] overflow-y-auto">
          <DialogHeader>
            <DialogTitle className="flex items-center gap-2">
              {activeMainTab === 'alacak' ? (
                <TrendingUp className="h-5 w-5 text-green-600" />
              ) : (
                <TrendingDown className="h-5 w-5 text-red-600" />
              )}
              {editingTakip ? 'Takip Düzenle' : `${activeMainTab === 'alacak' ? 'Alacak' : 'Borç'} Ekle`}
            </DialogTitle>
          </DialogHeader>
          <div className="space-y-4 py-4">
            {/* Oluşturulma Tarihi */}
            <div className="space-y-2">
              <Label htmlFor="olusturma_tarihi">Oluşturulma Tarihi</Label>
              <Input
                id="olusturma_tarihi"
                type="date"
                value={form.olusturma_tarihi}
                onChange={(e) => setForm({ ...form, olusturma_tarihi: e.target.value })}
                data-testid="takip-tarih"
              />
            </div>

            {/* Cari Hesap */}
            <div className="space-y-2">
              <Label>Cari Hesap *</Label>
              <Popover open={cariOpen} onOpenChange={setCariOpen}>
                <PopoverTrigger asChild>
                  <Button
                    variant="outline"
                    role="combobox"
                    aria-expanded={cariOpen}
                    className="w-full justify-between font-normal"
                    data-testid="takip-cari-select"
                  >
                    {form.cari_hesap_adi || "Cari hesap seçin..."}
                    <ChevronsUpDown className="ml-2 h-4 w-4 shrink-0 opacity-50" />
                  </Button>
                </PopoverTrigger>
                <PopoverContent className="w-full p-0" align="start">
                  <Command>
                    <CommandInput placeholder="Cari hesap ara..." />
                    <CommandList>
                      <CommandEmpty>Cari hesap bulunamadı.</CommandEmpty>
                      <CommandGroup>
                        {cariHesaplar.map((cari) => (
                          <CommandItem
                            key={cari.id}
                            value={cari.ad}
                            onSelect={() => {
                              setForm({
                                ...form,
                                cari_hesap_id: cari.id,
                                cari_hesap_adi: cari.ad
                              });
                              setCariOpen(false);
                            }}
                          >
                            <Check
                              className={cn(
                                "mr-2 h-4 w-4",
                                form.cari_hesap_id === cari.id ? "opacity-100" : "opacity-0"
                              )}
                            />
                            {cari.ad}
                          </CommandItem>
                        ))}
                      </CommandGroup>
                    </CommandList>
                  </Command>
                </PopoverContent>
              </Popover>
            </div>

            {/* Fatura Miktarı - Zorunlu Alan */}
            <div className="space-y-2 p-4 bg-amber-50 rounded-lg border border-amber-200">
              <Label className="flex items-center gap-2 text-amber-800 font-semibold">
                <FileText className="h-4 w-4" />
                {activeMainTab === 'alacak' ? 'Kesilmesi Gereken Fatura *' : 'Alınması Gereken Fatura *'}
              </Label>
              <p className="text-xs text-amber-600 mb-2">
                {activeMainTab === 'alacak' 
                  ? 'Bu alacak için kesilmesi gereken fatura miktarını girin. (Biz fatura keseceğiz)'
                  : 'Bu borç için alınması gereken fatura miktarını girin. (Bize fatura gelecek)'}
              </p>
              <div className="flex gap-2">
                <Input
                  type="number"
                  placeholder="Fatura miktarı girin..."
                  value={form.fatura_miktari}
                  onChange={(e) => setForm({ ...form, fatura_miktari: e.target.value })}
                  className="flex-1 bg-white"
                  data-testid="takip-fatura-miktari"
                />
                <span className="flex items-center px-3 bg-white border rounded-md text-sm text-gray-600">
                  {form.para_birimi === 'TL' ? '₺' : form.para_birimi === 'USD' ? '$' : '€'}
                </span>
              </div>
            </div>

            {/* Etiket */}
            <div className="space-y-2">
              <Label>Etiket (Hesap Kartı)</Label>
              <Popover open={etiketOpen} onOpenChange={setEtiketOpen}>
                <PopoverTrigger asChild>
                  <Button
                    variant="outline"
                    role="combobox"
                    aria-expanded={etiketOpen}
                    className="w-full justify-between font-normal"
                    data-testid="takip-etiket-select"
                  >
                    {form.etiket_adi || "Etiket seçin..."}
                    <ChevronsUpDown className="ml-2 h-4 w-4 shrink-0 opacity-50" />
                  </Button>
                </PopoverTrigger>
                <PopoverContent className="w-full p-0" align="start">
                  <Command>
                    <CommandInput placeholder="Etiket ara..." />
                    <CommandList>
                      <CommandEmpty>Etiket bulunamadı.</CommandEmpty>
                      <CommandGroup>
                        {hesapKartlari.map((etiket) => (
                          <CommandItem
                            key={etiket.id}
                            value={etiket.kayit_adi}
                            onSelect={() => {
                              setForm({
                                ...form,
                                etiket_id: etiket.id,
                                etiket_adi: etiket.kayit_adi
                              });
                              setEtiketOpen(false);
                            }}
                          >
                            <Check
                              className={cn(
                                "mr-2 h-4 w-4",
                                form.etiket_id === etiket.id ? "opacity-100" : "opacity-0"
                              )}
                            />
                            {etiket.kayit_adi}
                          </CommandItem>
                        ))}
                      </CommandGroup>
                    </CommandList>
                  </Command>
                </PopoverContent>
              </Popover>
            </div>

            {/* Fortis Şube */}
            <div className="space-y-2">
              <Label>Fortis Şube</Label>
              <Select 
                value={form.fortis_sube_id} 
                onValueChange={(value) => {
                  const selectedBranch = branches.find(b => b.id === value);
                  setForm({
                    ...form,
                    fortis_sube_id: value,
                    fortis_sube: selectedBranch?.name || ''
                  });
                }}
              >
                <SelectTrigger data-testid="takip-sube-select">
                  <SelectValue placeholder="Şube seçin..." />
                </SelectTrigger>
                <SelectContent>
                  {branches.map((branch) => (
                    <SelectItem key={branch.id} value={branch.id}>
                      {branch.name}
                    </SelectItem>
                  ))}
                </SelectContent>
              </Select>
            </div>

            {/* Ödeme Planı */}
            <div className="space-y-4 p-4 bg-gray-50 rounded-lg border">
              <div className="flex items-center justify-between">
                <Label className="text-base font-semibold">Ödeme Planı</Label>
                <div className="flex items-center gap-2">
                  <Label className="text-sm">Ödeme Sayısı:</Label>
                  <Select 
                    value={String(form.odeme_sayisi)} 
                    onValueChange={handleOdemeSayisiChange}
                  >
                    <SelectTrigger className="w-20" data-testid="odeme-sayisi-select">
                      <SelectValue />
                    </SelectTrigger>
                    <SelectContent>
                      {[1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12].map((n) => (
                        <SelectItem key={n} value={String(n)}>{n}</SelectItem>
                      ))}
                    </SelectContent>
                  </Select>
                </div>
              </div>

              <div className="space-y-4">
                {form.odemeler.map((odeme, index) => (
                  <Card key={index} className="p-4 bg-white">
                    <div className="flex items-center gap-2 mb-3">
                      <Badge variant="outline">{index + 1}. Ödeme</Badge>
                    </div>
                    <div className="grid grid-cols-1 md:grid-cols-3 gap-3">
                      <div className="space-y-1">
                        <Label className="text-xs">Ödeme Tarihi</Label>
                        <Input
                          type="date"
                          value={odeme.tarih || ''}
                          onChange={(e) => handleOdemeChange(index, 'tarih', e.target.value)}
                          data-testid={`odeme-tarih-${index}`}
                        />
                      </div>
                      <div className="space-y-1">
                        <Label className="text-xs">Tutar</Label>
                        <div className="flex gap-1">
                          <Input
                            type="number"
                            placeholder="0.00"
                            value={odeme.tutar || ''}
                            onChange={(e) => handleOdemeChange(index, 'tutar', e.target.value)}
                            className="flex-1"
                            data-testid={`odeme-tutar-${index}`}
                          />
                          {index === 0 && (
                            <Select 
                              value={form.para_birimi} 
                              onValueChange={(val) => setForm({ ...form, para_birimi: val })}
                            >
                              <SelectTrigger className="w-20" data-testid="takip-para-birimi">
                                <SelectValue />
                              </SelectTrigger>
                              <SelectContent>
                                <SelectItem value="TL">₺ TL</SelectItem>
                                <SelectItem value="USD">$ USD</SelectItem>
                                <SelectItem value="EUR">€ EUR</SelectItem>
                              </SelectContent>
                            </Select>
                          )}
                        </div>
                      </div>
                      <div className="space-y-1">
                        <Label className="text-xs">Ödeme Şekli</Label>
                        <Select 
                          value={odeme.odeme_sekli || 'havale_eft'} 
                          onValueChange={(v) => handleOdemeChange(index, 'odeme_sekli', v)}
                        >
                          <SelectTrigger data-testid={`odeme-sekli-${index}`}>
                            <SelectValue />
                          </SelectTrigger>
                          <SelectContent>
                            <SelectItem value="havale_eft">
                              <div className="flex items-center gap-2">
                                <Banknote className="h-4 w-4" />
                                Havale/EFT
                              </div>
                            </SelectItem>
                            <SelectItem value="cek">
                              <div className="flex items-center gap-2">
                                <FileText className="h-4 w-4" />
                                Çek
                              </div>
                            </SelectItem>
                            <SelectItem value="nakit">
                              <div className="flex items-center gap-2">
                                <CreditCard className="h-4 w-4" />
                                Nakit
                              </div>
                            </SelectItem>
                          </SelectContent>
                        </Select>
                      </div>
                    </div>

                    {/* Çek Resmi Yükleme - sadece çek seçildiğinde */}
                    {odeme.odeme_sekli === 'cek' && (
                      <div className="mt-3 space-y-2">
                        <Label className="text-xs">Çek Resmi</Label>
                        <div className="flex items-center gap-3">
                          <Input
                            type="file"
                            accept="image/*"
                            onChange={(e) => handleCekImageUpload(index, e)}
                            className="text-sm"
                          />
                          {odeme.cek_resmi && (
                            <div className="flex items-center gap-2">
                              <Image className="h-4 w-4 text-green-600" />
                              <span className="text-xs text-green-600">Yüklendi</span>
                            </div>
                          )}
                        </div>
                      </div>
                    )}
                  </Card>
                ))}
              </div>
            </div>

            {/* Açıklama */}
            <div className="space-y-2">
              <Label htmlFor="aciklama">Açıklama</Label>
              <Textarea
                id="aciklama"
                placeholder="Açıklama yazın..."
                value={form.aciklama}
                onChange={(e) => setForm({ ...form, aciklama: e.target.value })}
                data-testid="takip-aciklama"
              />
            </div>

            {/* Çoklu Belge Yükleme */}
            <div className="space-y-2 p-4 bg-gray-50 rounded-lg border">
              <Label className="flex items-center gap-2">
                <FileText className="h-4 w-4" />
                Belgeler
              </Label>
              <div className="flex items-center gap-3">
                <Input
                  type="file"
                  accept="image/*,.pdf"
                  multiple
                  onChange={handleFileUpload}
                  className="text-sm"
                  data-testid="takip-belgeler-input"
                />
                <Button type="button" variant="outline" size="sm" onClick={() => document.querySelector('[data-testid="takip-belgeler-input"]').click()}>
                  <Upload className="h-4 w-4 mr-1" />
                  Yükle
                </Button>
              </div>
              {form.belgeler && form.belgeler.length > 0 && (
                <div className="mt-3 space-y-2">
                  <Label className="text-xs text-gray-500">Yüklenen Belgeler ({form.belgeler.length})</Label>
                  <div className="flex flex-wrap gap-2">
                    {form.belgeler.map((belge, index) => (
                      <div key={index} className="flex items-center gap-2 bg-white px-3 py-2 rounded border text-sm">
                        <FileText className="h-4 w-4 text-blue-600" />
                        <span className="max-w-[150px] truncate">{belge.name}</span>
                        <button
                          type="button"
                          onClick={() => removeBelge(index)}
                          className="text-red-500 hover:text-red-700"
                        >
                          <X className="h-4 w-4" />
                        </button>
                      </div>
                    ))}
                  </div>
                </div>
              )}
            </div>
          </div>
          <DialogFooter>
            <Button variant="outline" onClick={() => setShowModal(false)}>
              İptal
            </Button>
            <Button 
              onClick={handleSubmit}
              className={activeMainTab === 'alacak' ? 'bg-green-600 hover:bg-green-700' : 'bg-red-600 hover:bg-red-700'}
              data-testid="save-takip-btn"
            >
              {editingTakip ? 'Güncelle' : 'Kaydet'}
            </Button>
          </DialogFooter>
        </DialogContent>
      </Dialog>

      {/* Detail Modal */}
      <Dialog open={showDetailModal} onOpenChange={setShowDetailModal}>
        <DialogContent className="sm:max-w-[700px] max-h-[90vh] overflow-y-auto">
          <DialogHeader>
            <DialogTitle className="flex items-center gap-2">
              {activeMainTab === 'alacak' ? (
                <TrendingUp className="h-5 w-5 text-green-600" />
              ) : (
                <TrendingDown className="h-5 w-5 text-red-600" />
              )}
              Takip Detayı - {selectedTakip?.seri_no}
            </DialogTitle>
          </DialogHeader>
          {selectedTakip && (
            <div className="space-y-4 py-4">
              {/* Genel Bilgiler */}
              <div className="bg-gray-50 rounded-lg p-4">
                <Label className="text-sm font-semibold text-gray-700 mb-3 block">Genel Bilgiler</Label>
                <div className="grid grid-cols-2 gap-4">
                  <div>
                    <Label className="text-xs text-gray-500">Seri No</Label>
                    <p className="font-medium text-blue-600">{selectedTakip.seri_no}</p>
                  </div>
                  <div>
                    <Label className="text-xs text-gray-500">Oluşturulma Tarihi</Label>
                    <p className="font-medium">{selectedTakip.olusturma_tarihi}</p>
                  </div>
                  <div>
                    <Label className="text-xs text-gray-500">Cari Hesap</Label>
                    <p className="font-medium">{selectedTakip.cari_hesap_adi || '-'}</p>
                  </div>
                  <div>
                    <Label className="text-xs text-gray-500">Etiket (Hesap Kartı)</Label>
                    <p className="font-medium">{selectedTakip.etiket_adi || '-'}</p>
                  </div>
                  <div>
                    <Label className="text-xs text-gray-500">Fortis Şube</Label>
                    <p className="font-medium">{selectedTakip.fortis_sube || '-'}</p>
                  </div>
                  <div>
                    <Label className="text-xs text-gray-500">Durum</Label>
                    <Badge className={selectedTakip.durum === 'tamamlandi' ? 'bg-green-600' : selectedTakip.durum === 'devam_ediyor' ? 'bg-blue-600' : 'bg-gray-600'}>
                      {selectedTakip.durum === 'tamamlandi' ? 'Tamamlandı' : selectedTakip.durum === 'devam_ediyor' ? 'Devam Ediyor' : selectedTakip.durum || 'Bekliyor'}
                    </Badge>
                  </div>
                </div>
              </div>

              {/* Finansal Bilgiler */}
              <div className="bg-blue-50 rounded-lg p-4">
                <Label className="text-sm font-semibold text-gray-700 mb-3 block">Finansal Bilgiler</Label>
                <div className="grid grid-cols-2 gap-4">
                  <div>
                    <Label className="text-xs text-gray-500">Toplam Tutar</Label>
                    <p className={`font-bold text-lg ${activeMainTab === 'alacak' ? 'text-green-600' : 'text-red-600'}`}>
                      {formatCurrency(selectedTakip.toplam_tutar, selectedTakip.para_birimi || 'TL')}
                    </p>
                  </div>
                  <div>
                    <Label className="text-xs text-gray-500">Anlaşılan Fatura Miktarı</Label>
                    <p className="font-bold text-lg text-indigo-600">
                      {selectedTakip.fatura_miktari ? formatCurrency(parseFloat(selectedTakip.fatura_miktari), selectedTakip.para_birimi || 'TL') : '-'}
                    </p>
                  </div>
                  <div>
                    <Label className="text-xs text-gray-500">Para Birimi</Label>
                    <p className="font-medium">{selectedTakip.para_birimi || 'TL'}</p>
                  </div>
                  <div>
                    <Label className="text-xs text-gray-500">Ödeme Sayısı</Label>
                    <p className="font-medium">{selectedTakip.odemeler?.length || 0} Taksit</p>
                  </div>
                </div>
              </div>

              {/* Açıklama */}
              {selectedTakip.aciklama && (
                <div className="bg-yellow-50 rounded-lg p-4">
                  <Label className="text-xs text-gray-500 mb-1 block">Açıklama</Label>
                  <p className="text-sm whitespace-pre-wrap">{selectedTakip.aciklama}</p>
                </div>
              )}

              {/* Belgeler */}
              <div className="bg-gray-50 rounded-lg p-4">
                <Label className="text-sm font-semibold text-gray-700 mb-3 block flex items-center gap-2">
                  <FileText className="h-4 w-4" />
                  Belgeler
                </Label>
                {selectedTakip.belgeler && selectedTakip.belgeler.length > 0 ? (
                  <div className="space-y-2">
                    {selectedTakip.belgeler.map((belge, index) => {
                      const belgeUrl = typeof belge === 'string' ? belge : belge.url;
                      const belgeName = typeof belge === 'string' ? `Belge ${index + 1}` : (belge.name || `Belge ${index + 1}`);
                      return (
                        <div key={index} className="flex items-center justify-between bg-white p-3 rounded border">
                          <div className="flex items-center gap-2">
                            <FileText className="h-4 w-4 text-blue-500" />
                            <span className="text-sm">{belgeName}</span>
                          </div>
                          <div className="flex gap-2">
                            <Button
                              variant="outline"
                              size="sm"
                              onClick={() => window.open(belgeUrl, '_blank')}
                            >
                              <Eye className="h-4 w-4 mr-1" />
                              Aç
                            </Button>
                            <Button
                              variant="outline"
                              size="sm"
                              asChild
                            >
                              <a href={belgeUrl} download={belgeName}>
                                <Download className="h-4 w-4 mr-1" />
                                İndir
                              </a>
                            </Button>
                          </div>
                        </div>
                      );
                    })}
                  </div>
                ) : (
                  <p className="text-sm text-gray-500 italic">Belge bulunamadı</p>
                )}
              </div>

              {/* Ödeme Planı */}
              <div className="border-t pt-4">
                <Label className="text-base font-semibold mb-3 block flex items-center gap-2">
                  <Calendar className="h-4 w-4" />
                  Ödeme Planı ({selectedTakip.odemeler?.length || 0} Taksit)
                </Label>
                <div className="space-y-2">
                  {selectedTakip.odemeler?.map((odeme, index) => (
                    <Card 
                      key={odeme.id} 
                      className={`p-3 ${odeme.odendi ? 'bg-green-50 border-green-200' : 'bg-white'}`}
                    >
                      <div className="flex items-center justify-between">
                        <div className="flex items-center gap-3">
                          <Badge variant={odeme.odendi ? "default" : "outline"} className={odeme.odendi ? "bg-green-600" : ""}>
                            {index + 1}. Ödeme
                          </Badge>
                          <div className="flex items-center gap-2">
                            {getOdemeSekliIcon(odeme.odeme_sekli)}
                            <span className="text-sm">{getOdemeSekliLabel(odeme.odeme_sekli)}</span>
                          </div>
                        </div>
                        <div className="flex items-center gap-4">
                          <div className="text-right">
                            <p className="font-semibold">{formatCurrency(odeme.tutar, selectedTakip.para_birimi || 'TL')}</p>
                            <p className="text-xs text-gray-500">
                              <Calendar className="h-3 w-3 inline mr-1" />
                              {odeme.tarih}
                            </p>
                          </div>
                          {!odeme.odendi && selectedTakip.durum !== 'tamamlandi' && (
                            <Button
                              size="sm"
                              variant="outline"
                              className="text-green-600 border-green-300 hover:bg-green-50"
                              onClick={() => openOdemeModal(selectedTakip, odeme)}
                            >
                              <CheckCircle className="h-4 w-4 mr-1" />
                              Ödendi
                            </Button>
                          )}
                          {odeme.odendi && (
                            <Badge className="bg-green-600">
                              <Check className="h-3 w-3 mr-1" />
                              Ödendi
                            </Badge>
                          )}
                        </div>
                      </div>
                      {/* Ödeme Detayları */}
                      <div className="mt-2 grid grid-cols-3 gap-2 text-xs text-gray-600">
                        {odeme.kalan_tutar !== undefined && (
                          <div>
                            <span className="text-gray-400">Kalan:</span>{' '}
                            <span className="font-medium">{formatCurrency(odeme.kalan_tutar, selectedTakip.para_birimi || 'TL')}</span>
                          </div>
                        )}
                        {odeme.odenen_tutar !== undefined && odeme.odenen_tutar > 0 && (
                          <div>
                            <span className="text-gray-400">Ödenen:</span>{' '}
                            <span className="font-medium text-green-600">{formatCurrency(odeme.odenen_tutar, selectedTakip.para_birimi || 'TL')}</span>
                          </div>
                        )}
                        {odeme.aciklama && (
                          <div className="col-span-3">
                            <span className="text-gray-400">Not:</span>{' '}
                            <span>{odeme.aciklama}</span>
                          </div>
                        )}
                      </div>
                      {odeme.odeme_sekli === 'cek' && odeme.cek_resmi && (
                        <div className="mt-2">
                          <a href={odeme.cek_resmi} target="_blank" rel="noopener noreferrer" className="text-xs text-blue-600 hover:underline flex items-center gap-1">
                            <Image className="h-3 w-3" />
                            Çek Resmini Görüntüle
                          </a>
                        </div>
                      )}
                      {odeme.odendi && odeme.odeme_tarihi && (
                        <p className="text-xs text-green-600 mt-1">
                          Ödeme Tarihi: {odeme.odeme_tarihi}
                        </p>
                      )}
                    </Card>
                  ))}
                </div>
              </div>
            </div>
          )}
          <DialogFooter>
            <Button variant="outline" onClick={() => setShowDetailModal(false)}>
              Kapat
            </Button>
          </DialogFooter>
        </DialogContent>
      </Dialog>

      {/* Mark Payment as Paid Modal */}
      <Dialog open={showOdemeModal} onOpenChange={setShowOdemeModal}>
        <DialogContent className="sm:max-w-[400px]">
          <DialogHeader>
            <DialogTitle className="flex items-center gap-2">
              <CheckCircle className="h-5 w-5 text-green-600" />
              Ödeme Tamamla
            </DialogTitle>
          </DialogHeader>
          <div className="space-y-4 py-4">
            <p className="text-sm text-gray-600">
              Bu ödemeyi tamamlandı olarak işaretlemek istediğinizden emin misiniz?
            </p>
            {selectedOdeme && (
              <Card className="p-3 bg-gray-50">
                <p className="font-semibold">{formatCurrency(selectedOdeme.tutar, selectedTakip?.para_birimi || 'TL')}</p>
                <p className="text-xs text-gray-500">Vade: {selectedOdeme.tarih}</p>
              </Card>
            )}
            <div className="space-y-2">
              <Label>Ödeme Tarihi</Label>
              <Input
                type="date"
                value={odemeForm.odeme_tarihi}
                onChange={(e) => setOdemeForm({ ...odemeForm, odeme_tarihi: e.target.value })}
              />
            </div>
            <div className="space-y-2">
              <Label>Açıklama</Label>
              <Textarea
                placeholder="Açıklama ekleyin..."
                value={odemeForm.aciklama}
                onChange={(e) => setOdemeForm({ ...odemeForm, aciklama: e.target.value })}
              />
            </div>
          </div>
          <DialogFooter>
            <Button variant="outline" onClick={() => setShowOdemeModal(false)}>
              İptal
            </Button>
            <Button 
              onClick={handleMarkOdemePaid}
              className="bg-green-600 hover:bg-green-700"
            >
              <Check className="h-4 w-4 mr-1" />
              Ödendi Olarak İşaretle
            </Button>
          </DialogFooter>
        </DialogContent>
      </Dialog>

      {/* Document Preview Modal */}
      <DocumentPreviewModal
        open={showDocPreview}
        onOpenChange={setShowDocPreview}
        belgeler={previewBelgeler}
        title="Takip Belgeleri"
      />

      {/* Job Detail Popup */}
      <JobDetailPopup
        jobId={selectedJobId}
        isOpen={showJobPopup}
        onClose={() => {
          setShowJobPopup(false);
          setSelectedJobId(null);
        }}
      />
    </div>
  );
};

export default AccountingTakipler;
